import SVGParlour from '@img/parlour.svg'
import SVGKetchen from '@img/ketchen.svg'
import SVGBedrooms from '@img/bedrooms.svg'
import { imageSize } from '@lib/image/loader'
import { filter, forEach, isArray, isFunction, uniq } from 'lodash-es'
import { getVideoCover } from '@lib/video-url'
import SVGFloorPlans from '@img/floor-plans.svg'
import SVGPlay from '@img/play-circle.svg'

/**
 * 获取初始化图片数据
 * 
 * @param {Object} house 房源详情数据
 * @param {Function} tp useTranslations('house')
 */
export function getInitImages(house, th) {
  const { images, videoUrl, threeDView, imageTagTidy, floorImages } = house
  const vrThumbnail = '//s.hougarden.com/file/hg/lo/hglogo-min.png'

  const video = getVideoCover(videoUrl)
  const tagTidy = isArray(imageTagTidy) ? imageTagTidy : []
  
  // 户型图
  let floorPlan = filter(tagTidy, (f) => f.key === 'floor_plan')[0]?.images || []

  // 如果imageTagTidy中不存在户型图
  if(floorPlan.length === 0 && floorImages?.length > 0) {
    floorPlan = floorImages
    tagTidy.push({
      key: 'floor_plan',
      label: isFunction(th) ? th('floorPlans') : 'Floor plan',
      images: floorImages
    })
  }

  // 所有图片
  const allImages = uniq([...images, ...floorPlan])

  // Gallery options
  const galleryOptions = []
  let index = 0
  forEach(allImages, (url) => {
    galleryOptions.push({
      index: index++,
      original: imageSize(url, 1500),
      thumbnail: imageSize(url, 300),
      title: house.street 
    })
  })

  if(video) {
    allImages.push(video)
    galleryOptions.push({
      index: index++,
      type: 'youtube',
      original: videoUrl,
      thumbnail: video,
      title: house.street
    })
  }

  if(threeDView) {
    allImages.push(vrThumbnail)
    galleryOptions.push({
      index,
      type: 'iframe',
      original: threeDView,
      thumbnail: vrThumbnail,
      title: house.street 
    })
  }

  return {
    images,
    galleryOptions,
    tagTidy,
    floorPlan,
    allImages,
    threeDView,
    vrThumbnail,
    video,
    house
  }
}

/**
 * tp = useTranslations('profile')
 */
export function getImageAlt(house, tp) {
  const tmp = [house.address || house.h1]
  if(house.bedrooms) {
    tmp.push(tp('bedroomsCount', { n: house.bedrooms }))
  }
  if(house.bathrooms) {
    tmp.push(tp('bathroomsCount', { n: house.bathrooms }))
  }
  if(house.category?.name) {
    tmp.push(house.category.name)
  }

  return tmp.join(', ')
}

/**
 * 获取顶部图片项
 */
export function getCoverOptions({ house, ts, th }) {
  const { video, floorPlan, tagTidy, images, allImages } = getInitImages(house, th)
  const options = {
    floorPlan: { 
      url: floorPlan[0],
      icon: <SVGFloorPlans width="2rem" height="2rem" />,
      label: th('floorPlans'),
      key: 'floor_plan'
    },
    video: {
      url: video,
      icon: <SVGPlay width="2rem" height="2rem" />,
      label: th('videoPlaying'),
      key: 'video'
    },
    livingRoom: {
      url: filter(tagTidy, (f) => f.key === 'living_room')[0]?.images?.[0],
      icon: <SVGParlour width="2rem" height="2rem" />,
      label: th('parlour'),
      key: 'living_room'
    },
    kitchen: {
      url: filter(tagTidy, (f) => f.key === 'kitchen')[0]?.images?.[0],
      icon: <SVGKetchen width="2rem" height="2rem" />,
      label: th('kitchen'),
      key: 'kitchen'
    },
    bedroom: {
      url: filter(tagTidy, (f) => f.key === 'bedroom')[0]?.images?.[0],
      icon: <SVGBedrooms width="2rem" height="2rem" />,
      label: ts('bedrooms'),
      key: 'bedroom'
    },
    outside: {
      url: filter(tagTidy, (f) => f.key === 'real_estate_exterior')[0]?.images?.[0],
      key: 'real_estate_exterior',
    },
  }

  // 优先级别 户型图 > 视频 > 客厅 > 厨房 > 卧室 > 户外
  const orders = [
    'floorPlan', 'video', 'livingRoom', 'kitchen', 'bedroom', 'outside'
  ]

  // 保存临时的图片，方便最后第一张图片展示对比
  const tmp = []
  const result = []

  forEach(orders, (key) => {
    const item = options[key]
    if(item.url) {
      tmp.push(item.url)
      result.push(item)
    }
  })
  
  // 添加图片到头部
  for(let i = 0, len = images.length; i < len; i++) {
    if(tmp.indexOf(images[i]) === -1) {
      tmp.push(images[0])
      result.unshift({ url: images[0] })
      break
    }
  }

  // 添加图片到尾部
  forEach(images, (url) => {
    tmp.indexOf(url) === -1 && result.push({ url })
  })

  return {
    options: result.slice(0, 5),
    allImages,
  }
}
